<script>
export default {
  name: 'CandidateDetailItem',
  props: {
    icon: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
  },
}
</script>

<template>
  <div class="d-flex align-start mb-2">
    <div class="flex-shrink-0" style="width: 200px">
      <v-icon v-if="icon" size="20" class="mr-2 icon-black">{{ icon }}</v-icon>
      <span class="text-md-bold mr-2">{{ label }}</span>
    </div>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/r2b-colours';

.icon-black {
  color: $neutrals-black-and-white-black !important;
}
</style>
